@if (loading.isVisible()) {
  <div class="global-loader" role="status" aria-live="polite" data-test="global-loader">
    <div class="loader-card">
      <div class="loader-orbit" aria-hidden="true">
        <span></span>
        <span></span>
        <img
          [src]="
            preferences.theme() === 'dark'
              ? '/assets/images/global/logo-dark.webp'
              : '/assets/images/global/logo.webp'
          "
          alt=""
        />
      </div>
      <div class="loader-bars" aria-hidden="true">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
}
